import React from 'react';
import Options from '../Options';
import PageHeader from '../../tenant_portal/shared/PageHeader';
import { useParams } from 'react-router-dom';
import loginStyles from '../../../../stylesheets/components/login.module.scss';

const ActivateOptions = () => {
  const { activationKey } = useParams();
  return (
    <div className={loginStyles.loginRouteContent}>
      <PageHeader title="Activate login" includeBottomMargin={false} />
      <Options
        emailPath={`/login/activate/${activationKey}/email`}
        activationKey={activationKey}
      />
    </div>
  );
};

export default ActivateOptions;
